import { render, staticRenderFns } from "./consumerSolutions.vue?vue&type=template&id=0f0bf7aa&scoped=true&"
import script from "./consumerSolutions.vue?vue&type=script&lang=js&"
export * from "./consumerSolutions.vue?vue&type=script&lang=js&"
import style0 from "./consumerSolutions.vue?vue&type=style&index=0&id=0f0bf7aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0bf7aa",
  null
  
)

export default component.exports